import { Search, LayoutPanelTop, MousePointerClick } from "lucide-react";
import { Reveal, SectionLabel } from "../components/Reveal";

const ITEMS = [
  {
    icon: Search,
    title: "Fatti trovare",
    text: "Una presenza web curata rende più facile trovare e conoscere la tua attività.",
  },
  {
    icon: LayoutPanelTop,
    title: "Presentati al meglio",
    text: "Servizi, immagini, menu, prezzi e informazioni vengono presentati in modo professionale e ordinato.",
  },
  {
    icon: MousePointerClick,
    title: "Trasforma l'interesse in contatto",
    text: "Rendi immediato richiedere informazioni, telefonare, prenotare o inviare una richiesta.",
  },
];

export const WhyOnline = () => (
  <section id="perche-online" aria-labelledby="perche-online-title" className="bg-white">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="max-w-3xl">
        <SectionLabel>Perché un sito professionale</SectionLabel>
        <h2 id="perche-online-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-navy-dark sm:text-4xl">
          Porta la tua attività anche online.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-steel sm:text-lg">
          Oggi molte persone cercano un'attività sul web prima ancora di contattarla. Un sito
          professionale ti permette di presentarti nel modo giusto, raccogliere in un unico posto le
          informazioni più importanti e rendere più immediato il contatto con potenziali clienti.
        </p>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.1}>
            <article className="h-full rounded-xl border border-line bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-celeste hover:shadow-lg hover:shadow-navy/5">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-celeste-soft text-celeste-dark" aria-hidden="true">
                <item.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-5 font-display text-lg font-semibold text-navy-dark">{item.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-steel">{item.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
